import React, { Component, useEffect, useMemo, useRef } from 'react'

import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'

import highchartsSankey from 'highcharts/modules/sankey'
import highchartsDrilldown from 'highcharts/modules/drilldown'
import SolidGauge from 'highcharts/modules/solid-gauge'
import highcharts3D from 'highcharts/highcharts-3d'

import _ from 'lodash'

const style = { width: '100%', height: '100%', position: 'absolute' }

SolidGauge(Highcharts)
highchartsSankey(Highcharts)
highchartsDrilldown(Highcharts)
highcharts3D(Highcharts)

interface Props {
    config: Highcharts.Options
    callback: HighchartsReact.Props['callback']
    style: React.CSSProperties
}
// eslint-disable-next-line @typescript-eslint/ban-types
export default function LiveHighcharts(props: Props): JSX.Element {
    const chartRef = useRef<{ chart: Highcharts.Chart; container: React.MutableRefObject<HTMLDivElement> }>()
    const reflow = useMemo(() => _.debounce(() => chartRef?.current?.chart.reflow(), 200, { leading: false }), [])

    useEffect(() => {
        if (chartRef.current) {
            const container = chartRef.current.container.current

            container.style.height = '100%'
            container.style.width = '100%'

            const resizeObserver = new ResizeObserver(() => {
                reflow()
            })

            resizeObserver.observe(container)

            return () => resizeObserver.disconnect()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const { config = {}, callback = _.noop, style: propsStyle = {} } = props

    let chart = {}

    if (typeof config.chart != 'undefined') {
        chart = {
            chart: {
                ...config.chart
            }
        }
    }
    const configChart = {
        title: {
            text: ''
        },
        ...config,
        ...chart,
        credits: false
    }

    return (
        <HighchartsReact
            ref={chartRef}
            highcharts={Highcharts}
            containerProps={{
                style: {
                    ...style,
                    ...propsStyle
                }
            }}
            callback={callback}
            options={configChart}
        />
    )
}
